import {
  getApplicationPurpose,
  postApplicationPurpose,
  updateApplicationPurpose,
  deleteApplicationPurpose,
} from "@/services/application-purpose.service";

// initial state
const state = () => ({
  applicationPurposeModel: {},
});

// mutations
const mutations = {
  setApplicationPurposeModel(state, data) {
    state.applicationPurposeModel = data;
  },
};

// actions
const actions = {
  //Meslek Listesi
  async loadApplicationPurposeList() {
    return await getApplicationPurpose().then((response) => {
      let data = response.data.data;
      let items = data.items;
      items.map((item, index) => {
        item.index = index + 1;
      });
      return items;
    });
  },

  async postApplicationPurpose(vuexContext, data) {
    await postApplicationPurpose(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async updateApplicationPurpose(vuexContext, data) {
    await updateApplicationPurpose(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async deleteApplicationPurpose(vuexContext, data) {
    await deleteApplicationPurpose(data).then((response) => {
      let data = response;
      return data;
    });
  },

  addApplicationPurposeModel(vuexContext, data) {
    vuexContext.commit("setApplicationPurposeModel", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
